import type { FunctionComponent } from "react";

import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { useStyleLogoLinkProps } from "scmp-app/components/header/hooks";

import { Container, StyledLogoLink, StyledStyleLogoText } from "./styles";

export type HeaderFeaturesStyleTextLinkProps = HeaderFeatureCommonProps;

export const HeaderFeaturesStyleTextLink: FunctionComponent<HeaderFeaturesStyleTextLinkProps> = ({
  ...props
}) => {
  const styleLogoLinkProps = useStyleLogoLinkProps();

  return (
    <Container {...getResponsiveProps(props)}>
      <StyledLogoLink {...styleLogoLinkProps}>
        <StyledStyleLogoText />
      </StyledLogoLink>
    </Container>
  );
};

HeaderFeaturesStyleTextLink.displayName = "HeaderFeaturesStyleTextLink";
